<template>
    <div :class="['Application', { 'is-loading': !state.appLoaded }]">
        <BackNavigation v-if="!isDesktop && $route.name !== 'home'"/>
        <CustomCursor v-if="isDesktop"/>
        <CookieBar/>
        <PopupBrowser v-if="state.changeBrowser"/>
        <FullFrameBouton  v-if="isDesktop" />
        <Menu/>
        <transition 
            mode="in-out"
            appear
            :duration="{ enter: 2000, leave: 2000 }"
            v-on:enter="enterDirector"
            v-on:leave="leaveDirector">
        <Directors v-show="$route.matched[0].name.indexOf('directors') !== -1" ref="Director"  />
        </transition>
        <transition 
            mode="in-out"
            appear
            :duration="{ enter: 2000, leave: 2000 }"
            v-on:enter="enterNews"
            v-on:leave="leaveNews">
            <News v-show="$route.matched[0].name.indexOf('news') !== -1" ref="News"  />
        </transition>
        <transition 
            mode="out-in"
            appear
            v-on:enter="enter"
            v-on:leave="leave">
            <router-view   ref="currentView" :key="$route.fullPath"/>
        </transition>
    </div>
</template>

<script>

import Store from '@/stores/store.js'

import CustomCursor from '@/components/CustomCursor.vue'
import CookieBar from '@/components/CookieBar.vue'
import PopupBrowser from '@/components/PopupBrowser.vue'
import BackNavigation from '@/components/BackNavigation.vue'
import Directors from '@/views/Directors.vue'
import News from '@/views/News.vue'
import Menu from '@/components/Menu.vue'
import TweenMax from "gsap/TweenMax";
import FullFrameBouton from '@/components/FullFrameBouton.vue'

export default {
    name: 'Application',
    
    components: {
        Menu,
        CustomCursor,
        CookieBar,
        BackNavigation,
        PopupBrowser,
        Directors,
        News,
        FullFrameBouton
    },

    data() {
        return {
            state: Store.state,
            isDesktop: Store.isDesktop,
        }
    },

    mounted(){
        window.addEventListener('click', this.onGlobalClick );
    },

    methods: {
        //Use for navigation trigger on click
        onGlobalClick(){
            if( Store.isDesktop && Store.state.cursorText === "Back" ){
                if( Store.state.level == 2){
                    this.$router.push( this.$route.matched[0].path.replace('/:slug', '') )
                    return;
                }
                if( Store.state.level == 1){
                    this.$router.push( "/" )
                    return;
                }
            }
        },
        // Allow handle transition with JS and keep logic in the corresponding component
        // Allow having different javascript animations for a single <transition> tag
        // Still readable in a vue way
        // Working with every transition mode (in-out, out-int, mixed, appear)
        // https://forum.vuejs.org/t/cant-make-a-enter-transition-of-a-route-wait-to-leave-transition-of-another-route/3006/11?u=lateek35
        enter: function (el, done) {
            this.$refs.currentView.enterAnim(done);
        },
        leave: function (el, done) {
            this.from.leaveAnim(done);
        },

        /**
         * Triggers Directors & News animations
         */
        enterDirector: function (el, done) {
            setTimeout(() => {
                this.$refs.Director.enterAnim(done);
            }, 200);
        },
        leaveDirector: function (el, done) {
            this.$refs.Director.leaveAnim(done);    
        },

        enterNews: function (el, done) {
            setTimeout(() => {
                this.$refs.News.enterAnim(done);
            }, 200);
        },
        leaveNews: function (el, done) {
            this.$refs.News.leaveAnim(done);    
        },
    },

    watch:{
        $route (to, from){
            this.from = this.$refs.currentView;
        }
    } 
}
</script>


<style scoped lang="scss">
    .Application{
        opacity: 1;
        transition: all 1s;
        &.is-loading {
            opacity: 0;
        }
    }
</style>
